<ng-container>
  <div class="flex flex-row justify-around mt-3">
    <div class="flex-row">
      <label for="company" class="input-label">*Idade Minima</label>
      <input type="number" class="form-input w-24" />
    </div>
    <div>
      <label for="company" class="input-label">*Idade Máxima</label>
      <input type="number" class="form-input w-24" />
    </div>
    <div class="flex items-end">
      <button class="mr-3" (click)="duplicar.emit()"><img src="./assets/icons/add-blue.svg" alt="ADD" /></button>
      <button (click)="remover.emit()"><img src="./assets/icons/remove-red.svg" alt="ADD" /></button>
    </div>
  </div>
</ng-container>
